import { render, staticRenderFns } from "./AgreementAdd.vue?vue&type=template&id=2c0867eb&"
import script from "./AgreementAdd.vue?vue&type=script&lang=js&"
export * from "./AgreementAdd.vue?vue&type=script&lang=js&"
import style0 from "./AgreementAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports